import React from "react";
import { View } from "react-native";
import { useTranslation } from "locales";
import { ViPicker } from "./vi-picker";
import {
    ModalWrapper,
    StyleFunction,
    useModal,
    useThemedStyle,
} from "@venuepos/react-common";

type ViModalValue = { color: string };

type ViModalProps = {
    onClose: (value?: ViModalValue) => void;
    productId: string;
    onSave: () => void;
};

export function ViModal({ onClose, onSave, productId }: ViModalProps) {
    const [t] = useTranslation();
    const styles = useThemedStyle(styleFunc);

    return (
        <ModalWrapper
            onClose={() => onClose(undefined)}
            title={t(
                "backoffice.product.vi.modal_title",
                "Setup inventory products"
            )}
        >
            <View style={styles.container}>
                <ViPicker
                    onClose={onClose}
                    onSave={onSave}
                    productId={productId}
                />
            </View>
        </ModalWrapper>
    );
}

export function useViModal() {
    const { render } = useModal<ViModalValue | undefined>();
    return (props: Omit<ViModalProps, "onClose">) =>
        render(onClose => <ViModal {...props} onClose={onClose} />, true);
}

const styleFunc: StyleFunction = theme => ({
    container: {
        margin: theme.spacingScale * 2,
        marginTop: 0,
        gap: theme.spacingScale,
        alignItems: "center",
        flex: 1,

        minWidth: 200,
        minHeight: 300,
    },
});
